import { useEffect, useState } from 'react';
import { useLoader } from '@equifinance/shared';
import _ from 'lodash';
import useBrokerManagementApi from '../../api/useBrokerManagementApi';
import { Brokerage } from '../brokerages';
import { defaultCompany } from './Company';

export const useCompany = (id: string) => {
  const [company, setCompany] = useState<Brokerage>(defaultCompany);
  const { getCompany } = useBrokerManagementApi();
  const { addLoader, removeLoader } = useLoader();

  const updateCompany = async (field: string, value: any) => {
    setCompany((prev) => {
      const clone = _.cloneDeep(prev);
      const newCompany = _.set(clone, field, value);
      return {
        ...newCompany,
      };
    });
  };

  const fetchCompany = async () => {
    try {
      addLoader();
      const company = await getCompany(id);
      setCompany(company);
    } finally {
      removeLoader();
    }
  };

  useEffect(() => {
    fetchCompany();
  }, [id]);

  return {
    company,
    updateCompany,
    fetchCompany,
  };
};
